import { Axios } from 'axios';
import { API_ECS_BASE_URL_BY_ENV_TO_BASE_URL_MAP } from './http-client.constants.js';
import authInterceptor from './authInterceptor.js';
import feCommonDataHolder from '../fe-common.initialize.js';
import { getLocalisationDataFromStorage, getStandardLocale, REGION_LANG_HEADER, REGION_ID_HEADER } from './utils.js';

class HttpClient extends Axios {
    constructor(config){
        const baseURL = config.baseURlType ? API_ECS_BASE_URL_BY_ENV_TO_BASE_URL_MAP[config.baseURlType][feCommonDataHolder.getEnv()] : config.baseURL;
        config.headers = config.headers ?? {};
        super({
            ...config,
            baseURL
        }), this.entity_id_vs_auth_code = {};
        // Add interceptor to always get latest locale
        this.interceptors.request.use((config)=>{
            const localisationData = getLocalisationDataFromStorage();
            const locale = feCommonDataHolder.getLocale();
            if (locale && localisationData?.regionId) {
                config.headers = config.headers ?? {};
                config.headers[REGION_LANG_HEADER] = getStandardLocale(locale);
                config.headers[REGION_ID_HEADER] = localisationData.regionId;
            }
            return config;
        });
        if (config.withQuinceCustomerAuthorization) {
            this.interceptors.request.use(authInterceptor);
        }
    }
}

export { HttpClient as default };
//# sourceMappingURL=http-client.js.map
